











import { Vue, Component, Prop, Model, Ref } from 'vue-property-decorator';

import MonthCalendar from './month/MonthCalendar.vue';
import DetailedCalendar from './detailed/DetailedCalendar.vue';

import { CalendarType } from '@/components/calendar/types';
import { ISOCalendarDate } from '@/utils/date/types';

@Component({
    components: {},
    inheritAttrs: false,
})
export default class CalendarAdmin extends Vue {
    @Model('update:date') date!: ISOCalendarDate;
    @Prop({ default: CalendarType.Month }) type!: CalendarType;
    @Ref() readonly $calendar!: MonthCalendar | DetailedCalendar;

    get dateModel() {
        return this.date;
    }

    set dateModel(date) {
        this.$emit('update:date', date);
    }

    get calendarView() {
        if (this.type === CalendarType.Month) {
            return MonthCalendar;
        }

        return DetailedCalendar;
    }

    public goPreviousPage() {
        this.$calendar.goPreviousPage();
    }

    public goNextPage() {
        this.$calendar.goNextPage();
    }
}
